{
  "version": 1,
  "asset_id": "b909508b-c818-4067-b18d-2db60c7cf123",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/b909508b-c818-4067-b18d-2db60c7cf123/bahcesehir-hizli-elektrikci-7-24-dukkan-8.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/b909508b-c818-4067-b18d-2db60c7cf123/bahcesehir-hizli-elektrikci-7-24-dukkan-8.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-8.jpg",
  "size": 413431,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:19:05Z"
}
